import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "D:/Documents/React Projects/components/react-mui-draft-wysiwyg/node_modules/gatsby-theme-docz/src/base/Layout.js";
import MUIEditor, { MUIEditorState } from "../src";
import { Playground, Props } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "react-mui-draft-wysiwyg"
    }}>{`react-mui-draft-wysiwyg`}</h1>
    <blockquote>
      <p parentName="blockquote">{`React component that allows to use a rich editor based on Material UI and Draft-js`}</p>
    </blockquote>
    <p><a parentName="p" {...{
        "href": "https://www.npmjs.com/package/react-mui-draft-wysiwyg"
      }}><img alt="NPM" src="https://img.shields.io/npm/v/react-mui-draft-wysiwyg.svg" /></a>{`
`}<a parentName="p" {...{
        "href": "https://standardjs.com"
      }}><img alt="JavaScript Style Guide" src="https://img.shields.io/badge/code_style-standard-brightgreen.svg" /></a></p>
    <p><img alt="MUI Draft.js WYSIWYG" src="https://raw.githubusercontent.com/Kelsier90/react-mui-draft-wysiwyg/master/example/public/logo.png" /></p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <p>{`if you don't have Material UI installed yet:`}</p>
    <p><a parentName="p" {...{
        "href": "https://material-ui.com/getting-started/installation/"
      }}>{`https://material-ui.com/getting-started/installation/`}</a></p>
    <p>{`Then install the editor:`}</p>
    <p>{`With npm:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save @material-ui/icons draft-js react-mui-draft-wysiwyg
`}</code></pre>
    <p>{`Or with yarn:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn add @material-ui/icons draft-js react-mui-draft-wysiwyg
`}</code></pre>
    <h2 {...{
      "id": "imports"
    }}>{`Imports`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`import MUIEditor, { MUIEditorState } from "react-mui-draft-wysiwyg";
`}</code></pre>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'() => {\n  const [editorState, setEditorState] = React.useState(\n    MUIEditorState.createEmpty(),\n  )\n  const onChange = newState => {\n    setEditorState(newState)\n  }\n  return <MUIEditor editorState={editorState} onChange={onChange} />\n}'} __scope={{
      props,
      DefaultLayout,
      MUIEditor,
      MUIEditorState,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const [editorState, setEditorState] = React.useState(MUIEditorState.createEmpty());

        const onChange = newState => {
          setEditorState(newState);
        };

        return <MUIEditor editorState={editorState} onChange={onChange} mdxType="MUIEditor" />;
      }}
    </Playground>
    <h2 {...{
      "id": "muieditor-properties"
    }}>{`MUIEditor Properties`}</h2>
    <Props of={MUIEditor} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      